import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { WhatIsIt } from './components/WhatIsIt';
import { Testimonials } from './components/Testimonials';
import { MethodPhases } from './components/MethodPhases';
import { BonusesSection } from './components/BonusesSection';
import { KitProPremium } from './components/KitProPremium';
import { ComparisonTable } from './components/ComparisonTable';
import { PricingSection } from './components/PricingSection';
import { FAQ } from './components/FAQ';
import { VisionSection } from './components/VisionSection';
import { TwoOptions } from './components/TwoOptions';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
const META_PIXEL_ID = '1288158062997995';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // If pixel already initialized, just fire PageView
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    // Initialize fbq queue (the loaded script replaces it later)
    const fbq: any = function () {
      // eslint-disable-next-line prefer-rest-params
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    if (!window._fbq) window._fbq = fbq;
    // Safely append the pixel script (avoid the unsafe getElementsByTagName + parentNode pattern)
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    (document.head || document.documentElement).appendChild(script);
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
    // Noscript fallback pixel
    const noscriptImg = document.createElement('img');
    noscriptImg.height = 1;
    noscriptImg.width = 1;
    noscriptImg.style.display = 'none';
    noscriptImg.alt = '';
    noscriptImg.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
    document.body.appendChild(noscriptImg);
  }, []);
  return <div className="min-h-screen bg-background text-text font-sans selection:bg-primary/30 selection:text-primary-light overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <WhatIsIt data-id="element-3" />
      <Testimonials data-id="element-4" />
      <MethodPhases data-id="element-5" />
      <BonusesSection data-id="element-6" />
      <KitProPremium data-id="element-7" />
      <ComparisonTable data-id="element-8" />
      <PricingSection data-id="element-9" />
      <FAQ data-id="element-10" />
      <VisionSection data-id="element-11" />
      <TwoOptions data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
      <PurchaseNotification data-id="element-15" />
    </div>;
}